export enum IoniconsOutline {
  doc = 'document-text-outline',
  attach = 'attach-outline',
  settings = 'settings-outline',
  tags = 'pricetags-outline',
  tag = 'pricetag-outline',
  building = 'business-outline',
  users = 'people-outline',
  user = 'person-outline',
  logout = 'log-out-outline',
  copyright = 'ribbon-outline',
  timer = 'timer-outline',
  hourglass = 'hourglass-outline',
  helpCircle = 'help-circle-outline',
  arrowDownOutline = 'arrow-down-outline',
  copy = 'copy-outline',
  cube = 'cube-outline',
  camera = 'camera-outline',
  square = 'square-outline',
  boxes = 'file-tray-stacked-outline',
  videoCam = 'videocam-outline',
  support = 'help-buoy-outline',
  archive = 'archive-outline',
  home = 'home-outline',
  userCircle = 'person-circle-outline',
  lock = 'lock-closed-outline',
  lockOpen = 'lock-open-outline',
  open = 'open-outline',
  upload = 'cloud-upload-outline',
  storage = 'cloud-outline',
  emptyStorage = 'cloud-offline-outline',
  plus = 'add-outline',
  download = 'download-outline',
  infoCircle = 'information-circle-outline',
  warningCircle = 'alert-circle-outline',
  edit = 'create-outline',
  eye = 'eye-outline',
  eyeOff = 'eye-off-outline',
  calendarCheck = 'calendar-outline',
  ia = 'extension-puzzle-outline',
  check = 'checkmark-outline',
  minus = 'remove-outline',
  close = 'close',
  closeCircle = 'close-circle-outline',
  arrowLeft = 'arrow-back-outline',
  warning = 'warning-outline',
  mail = 'mail-outline',
  key = 'key-outline',
  comment = 'chatbubble-ellipses-outline',
  commentSquare = 'chatbox-outline',
  search = 'search-outline',
  send = 'send-outline',
  like = 'thumbs-up-outline',
  menu = 'menu-outline',
  palette = 'color-palette-outline',
  alarm = 'notifications-outline',
  alarmOff = 'notifications-off-outline',
  expand = 'chevron-forward-outline',
  collapse = 'chevron-back-outline',
  save = 'save-outline',
  doubleCheck = 'checkmark-done-outline',
  reload = 'refresh-outline',
  sync = 'sync-outline',
  star = 'star-outline',
  file = 'document-outline',
  arrowRight = 'arrow-forward-outline',
  database = 'server-outline',
  folder = 'folder-outline',
  trash = 'trash-outline',
  chevronForward = 'chevron-forward-outline',
  chevronBack = 'chevron-back-outline',
  build = 'build-outline',
  arrowUndo = 'arrow-undo-outline',
  print = 'print-outline',
  time = 'time-outline',
  globe = 'globe-outline',
  version = 'albums-outline',
  ellipses = 'ellipsis-horizontal-outline',
  ellipse = 'ellipse-outline',
  circleCheck = 'checkmark-circle-outline',
  circleStop = 'stop-circle-outline',
  circlePlay = 'play-circle-outline',
  bug = 'bug-outline',
  play = 'play-outline',
  arrowUp = 'chevron-up-outline',
  arrowDown = 'chevron-down-outline',
  caretDown = 'caret-down-outline',
  caretUp = 'caret-up-outline',
  caretRight = 'caret-forward-outline',
  caretLeft = 'caret-back-outline',
  shieldHalf = 'shield-half-outline',
  shieldCheckmark = 'shield-checkmark-outline',
  pencil = 'pencil-outline',
  tab = 'code-working-outline',
  tools = 'hammer',
  list = 'list-outline',
  tabWithoutArrow = 'contract-outline',
  checkbox = 'checkbox-outline',
  resetCol = 'medkit',
  codeSlash = 'code-slash-outline',
  code = 'code-outline',
  text = 'text-outline',
  statsChart = 'stats-chart-outline',
  filter = 'funnel-outline',
  qrcode = 'qr-code-outline',
  report = 'megaphone-outline',
}
